import { STATE_NAMES } from 'STATES';

export const isNoStateSelected = (states: any[]) => states.length === 0;
export const isSingleStateSelected = (states: any[]) => states.length === 1;
export const isMultipleStatesSelected = (states: any[]) => states.length > 1;

export const getLongStateName = (state: keyof typeof STATE_NAMES) => {
  return STATE_NAMES[state];
};
